import { useInfiniteQuery } from "@tanstack/react-query";
import { customRequest, queryParamsStringify } from "./DataProvider.utils";
import { INITIAL_PAGE } from "../constants/DataProvider.constants";

interface IFetchDataRequestProps {
  endpoint: string;
  baseURL?: string;
  params?: Record<string, any>;
  isExternal?: boolean; // specify to use internal api client for api request
  apiKey: string; // unique key for the query
  skipAccessToken?: boolean;
  enabled?: boolean;
}

export const useInfiniteLoading = <T>({
  baseURL,
  endpoint,
  params,
  isExternal = false,
  apiKey,
  skipAccessToken,
  enabled,
}: IFetchDataRequestProps) => {
  const fetchData = async ({ pageParam }) => {
    return customRequest<T & { total_pages: number }>({
      baseURL,
      endpoint,
      isExternal,
      payload: { ...params, page: pageParam },
      skipAccessToken,
    })
      .then((response) => {
        const total_pages = response?.data?.total_pages;
        const nextPage = pageParam < total_pages ? pageParam + 1 : undefined;
        return { data: response.data, nextPage };
      })
      .catch((error: any) => console.log({ reactLibError: error }));
  };

  const queryKey = [apiKey];
  if (params) {
    queryKey.push(queryParamsStringify(params));
  }

  return useInfiniteQuery({
    queryKey,
    initialPageParam: INITIAL_PAGE,
    queryFn: fetchData,
    getNextPageParam: (lastPage) => {
      return lastPage?.data?.[apiKey]?.length ? lastPage?.nextPage : undefined;
    },
    enabled,
  });
};
